import styled from 'styled-components';
import TruncatedDiv from './truncated-div';

/** @deprecated prefer using `maxLines` prop of any text component within @workramp/ui */
const FullWidthTruncatedDiv = ({ text, numLines, className }) => (
  <TruncatedDivWrapper className={className}>
    <TruncatedDiv text={text} numLines={numLines} />
  </TruncatedDivWrapper>
);

const TruncatedDivWrapper = styled.div`
  width: 100%;
`;

export default FullWidthTruncatedDiv;
